import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {Settings} from "@/constants/settings";
import {LocalizeClanStatus, Tr} from "@/i18n/i18n";
import {SceneName} from "@/model/scene-name";
import {BackpackPanel} from "@/scenes.ui/backpack-panel";
import {BadgeDetailPanel} from "@/scenes.ui/badge-detail-panel";
import BadgePanel from "@/scenes.ui/badge-panel";
import {BanReasonPanel} from "@/scenes.ui/ban-reason-panel";
import {ConfirmationPanel} from "@/scenes.ui/confirmation-panel";
import {ElixirPanel} from "@/scenes.ui/elixir-panel";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import {GiftInfoPanel} from "@/scenes.ui/gift-info-panel";
import GiftNavPanel from "@/scenes.ui/gift-nav-panel";
import {GiftsPanel} from "@/scenes.ui/gits-panel";
import {InfoPanel} from "@/scenes.ui/info-panel";
import {LangSelectPanel} from "@/scenes.ui/lang-select-panel";
import {PlayerActionButton} from "@/scenes.ui/player-action-button";
import ProfileActionsNavPanel from "@/scenes.ui/profile-actions-nav-panel";
import ProfileBadgesNavPanel from "@/scenes.ui/profile-badges-nav-panel";
import {ProfileBanPanel} from "@/scenes.ui/profile-ban-panel";
import ProfileCreaturesNavPanel from "@/scenes.ui/profile-creatures-nav-panel";
import {QualityPanel} from "@/scenes.ui/quality-panel";
import ClanScene from "@/scenes/clanScene";
import RoadScene from "@/scenes/roadScene";
import {IapService} from "@/services/iap-service";
import ClanStore from "@/store/clan";
import {ClanControlAction, ClanmanInfo, ClanShortInfo} from "@/store/clan/types";
import ConsumableStore from "@/store/consumable";
import {ConsumableSetting, ConsumableWithCount} from "@/store/consumable/types";
import GiftStore from "@/store/gift";
import {OwnedGiftDto} from "@/store/gift/types";
import ModerStore from "@/store/moderator";
import {BanReason} from "@/store/moderator/types";
import PlayerStore from "@/store/player";
import {AccessLevel, Lang, Player, Quality, UserSource} from "@/store/player/types";
import {Badge, PlayerAction, Profile} from "@/store/profile/types";
import SecurityStore from "@/store/security";
import ArenaUtils from "@/utils/arena-utils";
import AtlasUtils from "@/utils/atlas-utils";
import ClanUtils from "@/utils/clan-utils";
import {IntegrationUtils} from "@/utils/integration-utils";
import OnceCaller from "@/utils/once-caller";
import ProfileUtils from "@/utils/profile-utils";
import QualityUtils from "@/utils/quality-utils";
import SpriteUtils from "@/utils/sprite-utils";
import TextUtils from "@/utils/text-utils";
import CU from "../utils/c-u";
import {GiftGemsPanel} from './gift-gems-panel';
import Scene = Phaser.Scene;
import Container = Phaser.GameObjects.Container;
import Image = Phaser.GameObjects.Image;
import Text = Phaser.GameObjects.Text;
import {YaStorage} from "@/utils/ya-storage";

export default class ProfilePanel extends Container {

    private readonly WIDTH: number = CU.CANVAS_WIDTH;
    private readonly MAIL_ACCESS_LEVEL: number = 15;
    private readonly MAX_DISPLAYED_BADGES: number = 5;
    private readonly MAX_DISPLAYED_CREATURES: number = 6;

    private canvas: HTMLCanvasElement | undefined;

    private profile!: Profile;

    private back!: Image;

    private onSpeedButtonPressCallback!: (moveSpeedButton: PlayerActionButton) => void;
    private onSpeedButtonInit!: (moveSpeedButton: PlayerActionButton) => unknown;
    private onCreaturePanelPressCallback!: (sceneName: SceneName, params: any) => void;
    /** Вызывает панель диалога с поддержкой
     * @param id аккаунта поддержки в БД
     */
    private onMailButtonPressCallback!: (id: number, support: boolean) => void;
    private onPlayerBanCallback!: (timeInSeconds: number, banReason: BanReason, playerId: number) => void;
    private onPlayerUnbanCallback!: (playerId: number) => void;
    private onSoundButtonPressCallback!: (soundButton: PlayerActionButton) => void;
    private onSoundButtonInit!: (soundButton: PlayerActionButton) => unknown;
    private onCloseCallback!: () => unknown;
    private onGenderButtonPressCallback!: () => unknown;
    private onPaymentButtonPressCallback!: () => unknown;
    private onUiModeCallback!: () => unknown;
    private pushModeCallback!: () => unknown;
    private onRenameButtonPressCallback!: () => unknown;
    private onEmailOrPhoneButtonPressCallback!: () => unknown;
    private onManualButtonPressCallback!: () => unknown;
    private onPasswordButtonPressCallback!: () => unknown;
    private reloadSceneCallback!: () => unknown;
    private historyCallback!: () => unknown;
    private paymentsCallback!: () => unknown;
    private profileCallback: (playerId: number) => unknown
    private giftGemsCallback: (receiver: Profile) => unknown;
    private yaAccCallback: () => unknown;

    constructor(scene: Scene, canvas: HTMLCanvasElement, profile: Profile,
                onSpeedButtonPressCallback: (moveSpeedButton: PlayerActionButton) => unknown,
                onSpeedButtonInit: (moveSpeedButton: PlayerActionButton) => unknown,
                onCreaturePanelPressCallback: (sceneName: SceneName, params: any) => void,
                onMailButtonPressCallback: (id: number, support: boolean) => void,
                onPlayerBanCallback: (timeInSeconds: number, banReason: BanReason, playerId: number) => void,
                onPlayerUnbanCallback: (playerId: number) => void,
                onSoundButtonPressCallback: (soundButton: PlayerActionButton) => void,
                onSoundButtonInit: (soundButton: PlayerActionButton) => unknown,
                onCloseCallback: () => unknown,
                onGenderButtonPressCallback: () => unknown,
                onPaymentButtonPressCallback: () => unknown,
                onUiModeCallback: () => unknown,
                pushModeCallback: () => unknown,
                onRenameButtonPressCallback: () => unknown,
                onEmailOrPhoneButtonPressCallback: () => unknown,
                onPasswordButtonPressCallback: () => unknown,
                onManualButtonPressCallback: () => unknown,
                reloadSceneCallback: () => unknown,
                historyCallback: () => unknown,
                paymentsCallback: () => unknown,
                profileCallback: (playerId: number) => unknown,
                giftGemsCallback: (receiver: Profile) => unknown,
                yaAccCallback: () => unknown
                ) {
        super(scene);

        this.profile = profile;
        this.scene = scene;
        this.canvas = canvas;
        this.x = 0;

        this.onSpeedButtonPressCallback = onSpeedButtonPressCallback;
        this.onSpeedButtonInit = onSpeedButtonInit;
        this.onMailButtonPressCallback = onMailButtonPressCallback;
        this.onPlayerBanCallback = onPlayerBanCallback;
        this.onPlayerUnbanCallback = onPlayerUnbanCallback;
        this.onSoundButtonPressCallback = onSoundButtonPressCallback;
        this.onSoundButtonInit = onSoundButtonInit;
        this.onGenderButtonPressCallback = onGenderButtonPressCallback;
        this.onPaymentButtonPressCallback = onPaymentButtonPressCallback;
        this.onUiModeCallback = onUiModeCallback;
        this.pushModeCallback = pushModeCallback;
        this.onCloseCallback = onCloseCallback
        this.onRenameButtonPressCallback = onRenameButtonPressCallback;
        this.onEmailOrPhoneButtonPressCallback = onEmailOrPhoneButtonPressCallback;
        this.onPasswordButtonPressCallback = onPasswordButtonPressCallback;
        this.onManualButtonPressCallback = onManualButtonPressCallback;
        this.reloadSceneCallback = reloadSceneCallback;
        this.historyCallback = historyCallback;
        this.paymentsCallback = paymentsCallback;
        this.profileCallback = profileCallback;
        this.giftGemsCallback = giftGemsCallback;
        this.yaAccCallback = yaAccCallback;

        if (this.profile.properProfile) {
            this.onCreaturePanelPressCallback = onCreaturePanelPressCallback;
        }

        this.back = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK).setOrigin(0.5, 0);
        this.add(this.back);

        this.setupCreatures();
    }

    private setupCreatures() {

        const back = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_PROFILE, Keys.UI_SCENARIO_TASK_BACK).setOrigin(0.5, 0);
        SpriteUtils.setDispSize(back, this.WIDTH, 160 * CU.S);

        const titleLight = SpriteUtils.addSprite(this.scene, 0, back.y / CU.S + 24, Keys.ATLAS_UI, Keys.UI_PROFILE_TITLE_LIGHTER);

        const title = TextUtils.addTextByFamily(this.scene, "", 0, titleLight.y / CU.S + 4, '#d5b35b', 20,
            'normal', 420, Fonts.BENGALY_NORMAL)
            .setStroke('#000000', 1);

        let creaturesCountText = ' (' + String(this.profile.creatures.length) + '):';
        if (this.profile.properProfile) {
            title.setText(Tr('moi.geroi') + creaturesCountText);
        } else {
            title.setText(Tr('geroi') + creaturesCountText);
        }

        let creatureNavPanel = new ProfileCreaturesNavPanel(this.scene, this.canvas!, 0 , title.y / CU.S + 35,
            this.profile.creatures, this.onCreaturePanelPressCallback, this.MAX_DISPLAYED_CREATURES);

        let separator = SpriteUtils.addSprite(this.scene!, 0, back.y / CU.S + back.displayHeight / CU.S, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0.5, 0.5);

        this.add([back, titleLight, title, creatureNavPanel, separator]);

        this.setupRewards(separator.y / CU.S);
    }

    private setupRewards(y: number) {

        const titleLight = SpriteUtils.addSprite(this.scene, 0, y + 25, Keys.ATLAS_UI, Keys.UI_PROFILE_TITLE_LIGHTER);
        SpriteUtils.setDispSize(titleLight, 240, 64);

        const title = TextUtils.addTextByFamily(this.scene, Tr('nagradi.bracket') + this.profile.badges.length + "):", 0, titleLight.y / CU.S + 4, '#d5b35b', 20,
            'normal', 420, Fonts.BENGALY_NORMAL).setStroke('#000000', 1);

        let separator = SpriteUtils.addSprite(this.scene!, 0, y + 150, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0.5, 0.5);

        this.add([titleLight, title, separator]);

        if (this.profile.badges.length > 0) {
            let rewardNavPanel = new ProfileBadgesNavPanel(this.scene, this.canvas!, 0 , title.y + 30 * CU.S, this.profile.badges,
                (badgePanel: BadgePanel) => this.showBadgeDetailPanel(badgePanel), this.MAX_DISPLAYED_BADGES);
            this.add(rewardNavPanel);
        } else {
            const noRewardText = TextUtils.addTextByFamily(this.scene, Tr('nagrad.poka.net'), 0, title.y / CU.S + 54, '#cac8c3', 15,
                'italic', 400, Fonts.BENGALY_NORMAL).setStroke('#000000', 1);
            noRewardText.setPadding(10);
            this.add(noRewardText);
        }

        this.setupAchievements(separator.y / CU.S)
    }

    private setupAchievements(y: number) {

        const back = SpriteUtils.addImage(this.scene, 0, y, Keys.ATLAS_PROFILE, Keys.UI_SCENARIO_TASK_BACK).setOrigin(0.5, 0);

        const titleLight = SpriteUtils.addSprite(this.scene, 0, y + 25, Keys.ATLAS_UI, Keys.UI_PROFILE_TITLE_LIGHTER);

        const title = TextUtils.addTextByFamily(this.scene, Tr('dostizhenija'), 0, titleLight.y / CU.S + 4, '#d5b35b', 20,
            'normal', 420, Fonts.BENGALY_NORMAL).setStroke('#000000', 1);

        let titleX = 135 - 300-50;
        let valueX = 393 - 300-50;
        let fontSize = 14;

        let yy = titleLight.y / CU.S + 35;

        // =========================================

        let idTitle;
        let idValue;
        let sourceTitle;
        let sourceValue;
        let copyIcon;
        let copyIcon2;
        if (PlayerStore.hasModerAccess()) {
            let self = this;
            idTitle = TextUtils.addTextAdvanced(this.scene, 'ID:', titleX, yy,
                '#f1deab', fontSize, 'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

            idValue = TextUtils.addTextAdvanced(this.scene, String(this.profile.id), valueX, idTitle.y / CU.S,
                '#ffb44d', fontSize, 'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

            copyIcon = SpriteUtils.addSprite(this.scene, idValue.getRightCenter().x! / CU.S + 20, idValue.y / CU.S, Keys.ATLAS_PROFILE, Keys.UI_ARROW_RIGHT);

            copyIcon2 = SpriteUtils.addSprite(this.scene, idValue.getRightCenter().x! / CU.S + 60, idValue.y / CU.S, Keys.ATLAS_PROFILE, Keys.UI_ARROW_RIGHT);

            let copyFn = () => {
                IntegrationUtils.copyToClipboard(String(this.profile.id));
                new FeedbackPanel(self.scene, 'ID ' + String(this.profile.id) + ' ' + Tr('copied.large'), undefined, true).show();
            };
            let copyFn2 = () => {
                let text = '{{' + String('player' + this.profile.id) + '||' + String(this.profile.displayingName) + '}}';
                IntegrationUtils.copyToClipboard(text);
                new FeedbackPanel(self.scene, Tr('copied.id'), undefined, true).show();
            };

            idValue.setInteractive().on('pointerup', copyFn);
            copyIcon.setInteractive().on('pointerup', copyFn);
            copyIcon2.setInteractive().on('pointerup', copyFn2);

            yy += 30;

            sourceTitle = TextUtils.addTextAdvanced(this.scene, Tr('source'), titleX, yy,
                '#f1deab', fontSize, 'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

            sourceValue = TextUtils.addTextAdvanced(this.scene, String(this.profile.userSource), valueX, sourceTitle.y / CU.S,
                '#FFB44D', fontSize, 'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

            yy += 30;
        }

        // =========================================

        const levelAchiTitle = TextUtils.addTextAdvanced(this.scene, Tr('uroven') + ':', titleX, yy,
            '#cac8c3', fontSize, 'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

        let levelAchiValue = TextUtils.addTextAdvanced(this.scene, this.profile.level.toString(), valueX, levelAchiTitle.y / CU.S,
            '#8bb652',fontSize,'normal', 350, 'left',1, Fonts.BENGALY_NORMAL);

        yy += 30;

        const relevantOpponentAchiTitle = TextUtils.addTextAdvanced(this.scene, Tr('actualniy.protivnik') + ':', titleX, yy,
            '#cac8c3', fontSize, 'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

        let relevantOpponentAchiValue = TextUtils.addTextAdvanced(this.scene, this.profile.stair.toString(), valueX, relevantOpponentAchiTitle.y / CU.S,
            '#8bb652',fontSize,'normal', 350, 'left',1, Fonts.BENGALY_NORMAL);

        yy += 30;

        const battlesWonAchiTitle = TextUtils.addTextAdvanced(this.scene, Tr('viigrano.bitv'), titleX, yy,
            '#cac8c3', fontSize,'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

        let battlesWonValue = TextUtils.addTextAdvanced(this.scene, this.profile.battlesTotal.toString(), valueX, battlesWonAchiTitle.y / CU.S,
            '#8bb652', fontSize, 'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

        yy += 30;

        const bestWinAchiTitle = TextUtils.addTextAdvanced(this.scene, Tr('luchshaja.pobeda'), titleX, yy,
            '#cac8c3', fontSize,'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

        if (this.profile.bestVictoryStair > 0) {

            let creatureNameX = valueX;
            if (this.profile.bestVictoryStair <= 70 || (PlayerStore.getPlayer().stair > 70 && this.profile.bestVictoryStair <= 300) || PlayerStore.getPlayer().stair > 200) {
                let bestWinCreatureIcon = SpriteUtils.addSprite(this.scene, valueX, bestWinAchiTitle.y / CU.S, AtlasUtils.getCreatureRoadAtlas(this.profile.bestVictoryCreatureId), this.profile.bestVictoryCreatureId)
                    .setOrigin(0, 0.5);
                SpriteUtils.setDispSize(bestWinCreatureIcon, 30 * CU.S, 30 * CU.S);

                const bestWinCreatureIconBack = SpriteUtils.addImage(this.scene, valueX + 15, bestWinCreatureIcon.y / CU.S, Keys.ATLAS_UI, Keys.UI_PROFILE_TITLE_LIGHTER, 0.1, 0.8);
                this.add([bestWinCreatureIconBack, bestWinCreatureIcon]);
                creatureNameX += 35;
            }

            let bestWinValue = TextUtils.addTextAdvanced(this.scene, Tr('uroven').toUpperCase() + ' ' + this.profile.bestVictoryStair, creatureNameX, bestWinAchiTitle.y / CU.S,
                '#8bb652', fontSize, 'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

            this.add([bestWinValue]);

        } else {

            let bestWinValue = TextUtils.addTextAdvanced(this.scene, "-", valueX + 2, bestWinAchiTitle.y / CU.S,
                '#8bb652', fontSize, 'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

            this.add(bestWinValue);
        }

        yy += 30;

        const tasksDoneAchiTitle = TextUtils.addTextAdvanced(this.scene, Tr('zadaniy.vipolneno'), titleX, yy,
            '#cac8c3', fontSize,'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

        let tasksDoneAchiValue = TextUtils.addTextAdvanced(this.scene, this.profile.completedTasks.toString(), valueX, tasksDoneAchiTitle.y / CU.S,
            '#8bb652', fontSize, 'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

        yy += 30;

        const scenarioTasksDoneAchiTitle = TextUtils.addTextAdvanced(this.scene, Tr('iz.nih.stsenarnih'), titleX, yy,
            '#cac8c3', fontSize,'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

        let scenarioTasksDoneAchiValue = TextUtils.addTextAdvanced(this.scene, this.profile.completedScenarioTasks.toString(), valueX, scenarioTasksDoneAchiTitle.y / CU.S,
            '#8bb652', fontSize, 'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

        yy += 30;

        const arenaBattlesTitle = TextUtils.addTextAdvanced(this.scene, Tr('kubkov.na.arene'), titleX, yy,
            '#cac8c3', fontSize,'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

        let arenaLeagueIcon = SpriteUtils.addSprite(this.scene, valueX, arenaBattlesTitle.y / CU.S,  Keys.ATLAS_LEAGUE_SMALL, ArenaUtils.getLeagueImgSmall(this.profile.arenaLeague))
            .setOrigin(0, 0.5);
        SpriteUtils.setDispSize(arenaLeagueIcon, 30 * CU.S, 30 * CU.S);

        let arenaBattlesValue = TextUtils.addTextAdvanced(this.scene, this.profile.arenaPosition.toString(), valueX + 35, arenaBattlesTitle.y / CU.S,
            '#8bb652', fontSize, 'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

        yy += 30;

        const fractionPointsTitle = TextUtils.addTextAdvanced(this.scene, Tr('fraction.points'), titleX, yy,
            '#cac8c3', fontSize,'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

        let firstSign = this.profile.goodPoints > this.profile.evilPoints ? Keys.UI_PROFILE_GOOD_SIGN : Keys.UI_PROFILE_EVIL_SIGN;
        let secondSign = this.profile.goodPoints > this.profile.evilPoints ? Keys.UI_PROFILE_EVIL_SIGN : Keys.UI_PROFILE_GOOD_SIGN;;

        let firstCount = this.profile.goodPoints > this.profile.evilPoints ? this.profile.goodPoints : this.profile.evilPoints;
        let secondCount = this.profile.goodPoints > this.profile.evilPoints ? this.profile.evilPoints : this.profile.goodPoints;

        let goodPointsIcon = SpriteUtils.addSprite(this.scene, valueX, fractionPointsTitle.y / CU.S,  firstSign)
            .setOrigin(0, 0.5);
        SpriteUtils.setDispSize(goodPointsIcon, 30 * CU.S, 30 * CU.S);

        let goodPointsValue = TextUtils.addTextAdvanced(this.scene, firstCount+"", valueX + 35, fractionPointsTitle.y / CU.S,
            '#8bb652', fontSize, 'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

        let evilPointsIcon = SpriteUtils.addSprite(this.scene, goodPointsValue.getRightCenter().x! / CU.S + 20, fractionPointsTitle.y / CU.S,  secondSign)
            .setOrigin(0, 0.5);
        SpriteUtils.setDispSize(evilPointsIcon, 30 * CU.S, 30 * CU.S);

        let evilPointsValue = TextUtils.addTextAdvanced(this.scene, secondCount+"", goodPointsValue.getRightCenter().x! / CU.S + 55, fractionPointsTitle.y / CU.S,
            '#8bb652', fontSize, 'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

        yy += 30;

        let clanName = "";
        let clanStatus = this.profile.clanStatus.toUpperCase();
        let hasClan = false
        if(clanStatus.indexOf(",") != -1) {
            let parts = clanStatus.split(",");
            clanName = parts[0].trim();
            clanStatus = parts[1].trim();
            hasClan = true;
        }

        clanStatus = PlayerStore.getPlayer().lang != Lang.RU ? LocalizeClanStatus(clanStatus) : clanStatus;

        let clanPosition = TextUtils.addTextAdvanced(this.scene, hasClan ? clanStatus + ' ' : '',
            titleX, yy, '#8bb652', 14, 'normal', 400,
            'left', 1, Fonts.BENGALY_NORMAL);
        clanPosition.visible = hasClan;

        let clan = TextUtils.addTextAdvanced(this.scene,  (hasClan ? Tr('klana') +":": Tr('klan')),
            clanPosition.x / CU.S + clanPosition.width / CU.S + (hasClan? 7 : 0), yy, '#b1afaf', 14, 'normal', 400,
            'left', 1, Fonts.BENGALY_NORMAL);

        let clanValue  = TextUtils.addTextAdvanced(this.scene,  clanName, valueX, clan.y / CU.S,
            '#e1a049', 13, 'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);

        let self = this;
        clanValue.setInteractive().on('pointerup', function() {
            if (clanName){
                ClanStore.fetchClanInfo(self.profile.id).then((ci:ClanShortInfo|undefined) => {
                    if(ci){
                        try{
                            let roadScene = (self.scene as (RoadScene));//костыль
                            roadScene.openClanDetailsPanel(ci);
                        } catch (e) {
                            let clanScene = (self.scene as (ClanScene));//костыль
                            clanScene.openClanDetailsPanel(ci);
                        }
                    };
                })
            }
        });

        let underline = SpriteUtils.addSprite(this.scene!, clanValue.x / CU.S, clanValue.y / CU.S +10, Keys.IMG_YELLOW_DOT).setOrigin(0, 0.5);
        underline.setScale(clanValue.width/underline.width, 1);

        let clanValue2  = TextUtils.addTextAdvanced(this.scene,  clanStatus, clanValue.x / CU.S  + clanValue.width / CU.S, clan.y / CU.S,
            '#8bb652', 13, 'normal', 350, 'left', 1, Fonts.BENGALY_NORMAL);
        clanValue2.visible = !hasClan;

        // if (clanValue2.x + clanValue2.width + 20 > CU.CANVAS_WIDTH / 2){
        //     let offset = (clanValue2.x + clanValue2.width + 20) - CU.CANVAS_WIDTH / 2;
        //      clanValue2.text = this.replaceLastSymbolsWithDots(clanValue2.text, Math.round(clanValue2.text.length * offset / clanValue2.width));
        // }

        yy += 30;

        let separator = SpriteUtils.addSprite(this.scene!, 0, yy , Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR).setOrigin(0.5, 0.5);

        SpriteUtils.setDispSize(back, this.WIDTH, (yy - y + 132) * CU.S);

        this.add([back, titleLight, title, levelAchiTitle, levelAchiValue, relevantOpponentAchiTitle, relevantOpponentAchiValue, battlesWonAchiTitle, battlesWonValue, bestWinAchiTitle,
            tasksDoneAchiTitle, tasksDoneAchiValue, scenarioTasksDoneAchiTitle, scenarioTasksDoneAchiValue,
            arenaBattlesTitle, arenaLeagueIcon, arenaBattlesValue, fractionPointsTitle, goodPointsIcon, goodPointsValue,
            evilPointsIcon, evilPointsValue, clanPosition, clan, clanValue, clanValue2, underline,
            separator]);

        if (idTitle && idValue && copyIcon && copyIcon2 && sourceTitle && sourceValue) {
            this.add([idTitle, idValue, copyIcon, copyIcon2, sourceTitle, sourceValue]);
        }

        this.setupActions(separator.y / CU.S);

    }

    private replaceLastSymbolsWithDots(text:string, symbolsToReplaceCount: number){
        return text.substring(0, text.length-symbolsToReplaceCount) + "...";
    }

    private setupActions(y: number) {

        const titleLight = SpriteUtils.addSprite(this.scene, 0, y + 25, Keys.ATLAS_UI, Keys.UI_PROFILE_TITLE_LIGHTER);
        SpriteUtils.setDispSize(titleLight, 240, 64);

        const title = TextUtils.addTextByFamily(this.scene, Tr('deystvija') + ':', 0, titleLight.y / CU.S + 4, '#d5b35b', 20,
            'normal', 420, Fonts.BENGALY_NORMAL)
            .setStroke('#000000', 1);

        if (this.profile.properProfile) {
            this.setPlayerActions(y);
        } else {
            this.setEnemyActions(y);
        }

        let separator = SpriteUtils.addSprite(this.scene!, 0, y + 132, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR)
            .setOrigin(0.5, 0.5);

        this.add([titleLight, title, separator]);

        if (this.profile.giftsCount > 0) {
            this.setupGifts(separator.y);
        } else {
            this.setupInfo(separator.y);
        }
    }

    private setupGifts(y: number) {
        y = y / CU.S;
        let cnt = this.profile.giftsCount;
        let self = this;

        const titleLight = SpriteUtils.addSprite(this.scene, 0, y + 25, Keys.ATLAS_UI, Keys.UI_PROFILE_TITLE_LIGHTER);
        SpriteUtils.setDispSize(titleLight, 240, 64);

        const title = TextUtils.addTextByFamily(this.scene, Tr('gfts') + ' (' + cnt + ')', 0, titleLight.y / CU.S + 4, '#d5b35b', 20,
            'normal', 420, Fonts.BENGALY_NORMAL)
            .setStroke('#000000', 1);

        this.setupGiftNavPanel(title.y / CU.S + 30, title);

        let separator = SpriteUtils.addSprite(this.scene!, 0, y + 145, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR)
            .setOrigin(0.5, 0.5);

        this.add([titleLight, title, separator]);

        this.setupInfo(separator.y);
    }

    private setupGiftNavPanel(y: number, title: Text) {
        let self = this;
        let giftsNavPanel = new GiftNavPanel(this.scene, this.canvas!, 0, y * CU.S, this.profile.gifts, (giftId: number) => {
            let gi = new GiftInfoPanel(self.scene, self.canvas!);
            GiftStore.info(giftId).then((g: OwnedGiftDto) => {
                gi.init(g, self.profile.properProfile, (playerId: number) => {
                    self.profileCallback(playerId);
                }, () => {
                    this.profile.gifts = this.profile.gifts.filter(g => g.id !== giftId);
                    this.profile.giftsCount--;
                    GiftStore.delete(giftId).then(() => {
                        title.setText(Tr('gfts') + ' (' + self.profile.giftsCount + ')');
                        giftsNavPanel.destroy();
                        this.setupGiftNavPanel(y, title);
                    });
                }, () => {
                    GiftStore.setTextHidden(giftId, g.textHidden);
                    new FeedbackPanel(self.scene, g.textHidden ? Tr('t.h.all') : Tr('t.s.all'), undefined, true).show();
                });
            });
            gi.openAnimated();
        });
        this.add(giftsNavPanel);
    }

    private setupInfo(y: number) {
        y = y / CU.S;

        // const back = SpriteUtils.addImage(this.scene, 0, y, Keys.ATLAS_PROFILE, Keys.UI_SCENARIO_TASK_BACK)
        //     .setOrigin(0.5, 0);

        const titleLight = SpriteUtils.addSprite(this.scene, 0, y + 25/ CU.S, Keys.ATLAS_UI, Keys.UI_PROFILE_TITLE_LIGHTER);

        const title = TextUtils.addTextByFamily(this.scene, Tr('informatsija'), 0, titleLight.y / CU.S + 4 ,
            '#d5b35b', 20,'normal', 420, Fonts.BENGALY_NORMAL).setStroke('#000000', 1);

        let yy = titleLight.y / CU.S + 35 / CU.S;

        if (this.profile.accessLevel === AccessLevel.MODERATOR || this.profile.accessLevel === AccessLevel.ADMIN || this.profile.accessLevel === AccessLevel.GOD) {
            let extraStatus = TextUtils.addTextAdvanced(this.scene, ProfilePanel.getLevelInfo(this.profile.accessLevel),
                0, yy, '#6db7ff', 14, 'normal', 400,
                'center', 1, Fonts.BENGALY_NORMAL);
            this.add(extraStatus);
            yy = extraStatus.y / CU.S;
        } else if (this.profile.ban) {
            let ban = TextUtils.addTextAdvanced(this.scene, this.profile.ban, 0, yy, '#ff4f4f', 14, 'normal', 400,
                'center', 1, Fonts.BENGALY_NORMAL);
            this.add(ban);
            yy = ban.y / CU.S ;
        }

        yy += 24 / CU.S;

        let lastSeen = TextUtils.addTextAdvanced(this.scene, Tr('posledniy.vhod') + this.profile.lastActivityAt.toUpperCase(),
            0, yy, '#999794', 14, 'normal', 500,
            'center', 1, Fonts.BENGALY_NORMAL);

        yy += 24 / CU.S;

        let registered = TextUtils.addTextAdvanced(this.scene, Tr('nachalo.igri') + this.profile.startedGameAt,
            0, yy , '#999794', 14, 'normal', 500,
            'center', 1, Fonts.BENGALY_NORMAL);

        this.height = registered.y / CU.S + 40 / CU.S;

        let crazy = undefined;
        if (IntegrationUtils.isCrazyUser()) {
            yy += 24 / CU.S;

            crazy = TextUtils.addTextAdvanced(this.scene, 'crazygames.com',
                0, yy , '#999794', 14, 'normal', 500,
                'center', 1, Fonts.BENGALY_NORMAL);

            crazy.setInteractive().on('pointerup', () => {
                window.open('https://crazygames.com');
            });

            this.height = crazy.y / CU.S + 40 / CU.S;
        }

        SpriteUtils.setDispSize(this.back, this.WIDTH, this.height * CU.S);

        // SpriteUtils.setDispSize(back, this.WIDTH, this.height * CU.S - y * CU.S);
        let separator = SpriteUtils.addSprite(this.scene!, 0, this.height, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR)
            .setOrigin(0.5, 0.5);

        this.add([titleLight, title, lastSeen, registered, separator]);

        if (crazy) {
            this.add(crazy);
        }
    }

    private showBadgeDetailPanel(badgePanel: BadgePanel) {
        let badge: Badge = badgePanel.getPanelBadge();
        new BadgeDetailPanel(this.scene, this.canvas!, badge).open();
    }

    private setPlayerActions(y: number) {

        let buttonsContainer: PlayerActionButton[] = [];
        let player: Player = PlayerStore.getPlayer();

        // КНОПКА ПОМОЩЬ
        const helpButton = new PlayerActionButton(this.scene, 0, 0,Tr('podderzhka'), Keys.ATLAS_PROFILE, Keys.UI_PROFILE_HELP,100,() => {
            if (this.onMailButtonPressCallback != null) {
                this.closeProfilePanel();
                this.onMailButtonPressCallback(this.profile.supporterId, true);
            }
        });

        if (player.userSource === UserSource.ya && (player.level + 3 < YaStorage.getMaxLevel() || YaStorage.isUsedRemap())) {
            const yaAccButton = new PlayerActionButton(this.scene, 0, 0, Tr('acc'), Keys.ATLAS_UI, Keys.UI_PROFILE_NAME_CHANGE, 100, () => {
                if (this.yaAccCallback != null) {
                    this.yaAccCallback();
                }
            });
            buttonsContainer.push(yaAccButton);
        }

        // КНОПКА БОТИНКИ
        let moveSpeedButton = new PlayerActionButton(this.scene, 0, 0,Tr('nadet.sapogi.skorohodi'), Keys.ATLAS_UI, Keys.UI_PROFILE_BOOTS_OFF,130,() => {
            if (this.onSpeedButtonPressCallback != null) {
                this.onSpeedButtonPressCallback(moveSpeedButton);
            }
        });

        // КНОПКА ЗВУКИ
        let soundButton = new PlayerActionButton(this.scene, 0, 0,Tr('vikljuchit.zvuk'), Keys.ATLAS_UI, Keys.UI_PROFILE_SOUND_OFF, 110,() => {
            if (this.onSoundButtonPressCallback != null) {
                this.onSoundButtonPressCallback(soundButton);
            }
        });

        if (this.onSpeedButtonInit != null) {
            this.onSpeedButtonInit(moveSpeedButton);
        }

        if (this.onSoundButtonInit != null) {
            this.onSoundButtonInit(soundButton);
        }

        buttonsContainer.push(moveSpeedButton);
        buttonsContainer.push(soundButton);
        buttonsContainer.push(helpButton);

        // КНОПКА СОЦСЕТИ (ГРУППА)
        if (player.userSource === UserSource.ok || player.userSource === UserSource.vk) {
            const socialButton = new PlayerActionButton(this.scene, 0, 0,Tr('gruppa'), Keys.ATLAS_PROFILE, Keys.UI_PROFILE_SOCIAL,100,() => {
                this.invokeSocialButtonCallback(player.userSource);
            });
            buttonsContainer.push(socialButton);
        }

        if (player.stair >= Settings.MIN_ELIXIR_SETTINGS_STAIR) {
            // РЮКЗАК
            let self = this;
            const backpackButton = new PlayerActionButton(this.scene, 0, 0,Tr('backpack'), undefined, Keys.UI_BACKPACK_ICON,100,() => {

                OnceCaller.doOnce("openBackpack", () => {
                    ConsumableStore.getBackpackItems(BackpackPanel.HEIGHT_CELLS * BackpackPanel.WIDTH_CELLS).then((cs: ConsumableWithCount[]) => {

                        let bp: BackpackPanel = new BackpackPanel(self.scene, self.canvas!, cs, () => {
                            let css: ConsumableSetting[] | undefined = undefined;
                            let buttonPressed = false;

                            ConsumableStore.fetchSlotsSettings().then((cs: ConsumableSetting[]) => {
                                css = cs;
                                if (buttonPressed) {
                                    let ep: ElixirPanel = new ElixirPanel(self.scene, self.canvas!, cs, (cs: ConsumableSetting[]) => {
                                        ConsumableStore.setupSlotsSettings(cs);
                                        new FeedbackPanel(self.scene, Tr('slots.set'), undefined, true).show();
                                    });
                                    ep.openAnimated();
                                }
                            });

                            let ip: InfoPanel = new InfoPanel(self.scene, self.canvas!, Tr('cust'), Tr('consls'), Tr('cns.txt'), () => {
                                buttonPressed = true;
                                ip.close();
                                if (css) {
                                    let ep: ElixirPanel = new ElixirPanel(self.scene, self.canvas!, css, (cs: ConsumableSetting[]) => {
                                        ConsumableStore.setupSlotsSettings(cs);
                                        new FeedbackPanel(self.scene, Tr('slots.set'), undefined, true).show();
                                    });
                                    ep.openAnimated();
                                }
                            }, Tr('continue'));
                            ip.setDepth(3000);
                            ip.openAnimated();
                        });
                        bp.openAnimated();
                    });
                }, 500);
            });
            buttonsContainer.push(backpackButton);
        }

        // КНОПКА СМЕНЫ ПОЛА
        const genderButton = new PlayerActionButton(this.scene, 0, 0,Tr('smenit.pol'), Keys.ATLAS_UI, Keys.UI_GENDER_CHANGE,100,() => {
            if (this.onGenderButtonPressCallback != null) {
                this.closeProfilePanel();
                this.onGenderButtonPressCallback();
            }
        });

        buttonsContainer.push(genderButton);

        if (!CU.isDesktop() || window.location.href.indexOf('localhost') !== -1) {
            // КНОПКА СМЕНЫ КАЧЕСТВА КАНВАСА
            const quailityButton = new PlayerActionButton(this.scene, 0, 0, Tr('quality'), undefined, Keys.UI_QA_CHANGE, 100, () => {
                let qp = new QualityPanel(this.scene, this.canvas!, QualityUtils.getQuality(), (quality: Quality) => {
                    PlayerStore.setupQuality(quality);
                });
                qp.openAnimated();
            });
            buttonsContainer.push(quailityButton);
        }

        // КНОПКА СМЕНЫ СПОСОБА ОПЛАТЫ
        if (player.userSource === UserSource.own && !IapService.IapEnabled()) {
            const paymentTypeButton = new PlayerActionButton(this.scene, 0, 0, Tr('smenit.sposob.oplaty'), Keys.ATLAS_PROFILE, Keys.UI_PAYMENT_CHANGE, 100, () => {
                if (this.onPaymentButtonPressCallback != null) {
                    this.closeProfilePanel();
                    this.onPaymentButtonPressCallback();
                }
            });

            buttonsContainer.push(paymentTypeButton);
        }

        if (this.profile.accessLevel !== AccessLevel.TRIAL) {

            // КНОПКА СМЕНИТЬ ИМЯ
            const renameButton = new PlayerActionButton(this.scene, 0, 0,Tr('smenit.imja'), Keys.ATLAS_UI, Keys.UI_PROFILE_NAME_CHANGE,100,() => {
                if (this.onRenameButtonPressCallback != null) {
                    this.closeProfilePanel();
                    this.onRenameButtonPressCallback();
                }
            });

            buttonsContainer.push(renameButton);

            if (!IntegrationUtils.isExternalUser()) {
                const exitButton = new PlayerActionButton(this.scene, 0, 0,Tr('vihod'), Keys.ATLAS_UI, Keys.UI_PROFILE_EXIT,100,() => {
                    new ConfirmationPanel(this.scene!, this.canvas!, () => {
                        SecurityStore.logout();
                    }, Tr('vihod'), Tr('exit.sure'), Keys.UI_EXIT_DOOR, Tr('da'), Tr('net'), Keys.ATLAS_PROFILE).open();
                });

                buttonsContainer.push(exitButton);
            }
        }

        if (IntegrationUtils.isI18NEnabled() && !IntegrationUtils.isMirland()) {
            // СМЕНА ЯЗЫКА
            let self = this;
            const langButton = new PlayerActionButton(this.scene, 0, 0,Tr('lan'), Keys.ATLAS_PROFILE, Keys.UI_PROFILE_LANG,100,() => {
                let langPanel = new LangSelectPanel(self.scene, self.canvas!, () => {
                    self.reloadSceneCallback();
                }, Tr('lan'), Tr('select.lang'));
                langPanel.openAnimated();
            });
            buttonsContainer.push(langButton);
        }

        // КНОПКА СМЕНЫ UI
        const uiButton = new PlayerActionButton(this.scene, 0, 0, Tr('ui'), Keys.ATLAS_PROFILE, Keys.UI_UI_CHANGE, 100,() => {
            if (this.onUiModeCallback != null) {
                this.onUiModeCallback();
            }
        });
        buttonsContainer.push(uiButton);

        // КНОПКА СМЕНЫ ПОЧТЫ/ТЕЛЕФОНА
        if (this.profile.accessLevel !== AccessLevel.TRIAL &&  !IntegrationUtils.isExternalUser()) {
            const changeEmailOrPhoneButton = new PlayerActionButton(this.scene, 0, 0,Tr('email.phone'), Keys.ATLAS_PROFILE, Keys.UI_PROFILE_MAIL,100,() => {
                if (this.onEmailOrPhoneButtonPressCallback != null) {
                    this.onEmailOrPhoneButtonPressCallback();
                }
            });
            buttonsContainer.push(changeEmailOrPhoneButton);

            // КНОПКА СМЕНЫ ПАРОЛЯ
            const changePasswordButton = new PlayerActionButton(this.scene, 0, 0,Tr('passw.chng.header'), Keys.ATLAS_UI, Keys.UI_PROFILE_PASSWORD,100,() => {
                if (this.onPasswordButtonPressCallback != null) {
                    this.onPasswordButtonPressCallback();
                }
            });
            buttonsContainer.push(changePasswordButton);
        }

        const manualButton = new PlayerActionButton(this.scene, 0, 0,Tr('spr'), undefined, Keys.UI_MANUAL_ICON, 100,() => {
            OnceCaller.doOnce("toManualFromProfile", () => {
                if (this.onManualButtonPressCallback != null) {
                    this.onManualButtonPressCallback();
                }
            });
        });
        buttonsContainer.push(manualButton);

        if (player.creatures && player.creatures.length > 6) {
            const pushModeButton = new PlayerActionButton(this.scene, 0, 0, Tr('lvlng'), undefined, Keys.UI_PUSH_CHANGE, 100,() => {
                if (this.pushModeCallback != null) {
                    this.pushModeCallback();
                }
            });
            buttonsContainer.push(pushModeButton);
        }


        let actionsNavPanel = new ProfileActionsNavPanel(this.scene, this.canvas!, 0, y + 90, buttonsContainer);

        this.add([actionsNavPanel]);

    }

    private setEnemyActions(y: number) {
        const player: Player = PlayerStore.getPlayer();
        const buttonsContainer: PlayerActionButton[] = [];
        const resetEnemyActionsCallback = () => {
            actionsNavPanel.setVisible(false);
            actionsNavPanel.destroy();
            this.setEnemyActions(y);
        }

        buttonsContainer.push(this.createMailButton(player));
        if (player.stair >= Settings.MIN_GIFTS_LEVEL) {
            buttonsContainer.push(this.createGiftButton());
            buttonsContainer.push(this.createGiftGemsButton());
        }
        
        if (PlayerStore.hasAdminAccess()) {
            buttonsContainer.push(this.createMultsButton());
        }

        if (PlayerStore.hasModerAccess()) {
            buttonsContainer.push(this.createBanButton());
        }

        if (PlayerStore.hasAdminAccess()) {
            buttonsContainer.push(this.createEnterAsPlayerButton());
            buttonsContainer.push(this.createHistoryButton());
            buttonsContainer.push(this.createPaymentsButton());
            
            const upgradeToModerButton = this.createUpgradeToModerButton(resetEnemyActionsCallback);
            if (upgradeToModerButton) {
                buttonsContainer.push(upgradeToModerButton);
            }  
        }

        if (this.profile.clanControlActions) {
            this.profile.clanControlActions.forEach((ca: ClanControlAction) => {
                buttonsContainer.push(this.createClanActionButton(ca, resetEnemyActionsCallback));
            });
        }

        if (this.profile.playerActions) {
            this.profile.playerActions.forEach((a: PlayerAction) => {
                buttonsContainer.push(this.createPlayerActionButton(a, resetEnemyActionsCallback));
            });
        }

        const actionsNavPanel = new ProfileActionsNavPanel(this.scene, this.canvas!, 0, y + 90, buttonsContainer);
        this.add([actionsNavPanel]);
    }

    private createMailButton(player: Player): PlayerActionButton {
        const self = this;

        // КНОПКА НАПИСАТЬ ПИСЬМО
        return new PlayerActionButton(this.scene, 0, 0,Tr('otpravit.pismo'), Keys.ATLAS_PROFILE, Keys.UI_PROFILE_MAIL, 110,() => {
            if (self.onMailButtonPressCallback != null) {
                if (player.level >= self.MAIL_ACCESS_LEVEL) {
                    self.closeProfilePanel();
                    self.onMailButtonPressCallback(self.profile.id, false);
                } else {
                    new FeedbackPanel(self.scene!,
                        Tr('neobhodimo.poluchit') + self.MAIL_ACCESS_LEVEL + ' ' + Tr('uroven').toLowerCase(),
                        undefined, false).show();
                }
            }
        });
    }

    private createGiftButton(): PlayerActionButton {
        const self = this;

        // КНОПКА "ПОДАРИТЬ ПОДАРОК"
        return new PlayerActionButton(self.scene, 0, 0, Tr('mk.gft'), Keys.ATLAS_PROFILE, Keys.UI_PROFILE_GIFT, 110, () => {
            const gp = new GiftsPanel(self.scene, self.canvas!, (giftId: string, message: string) => {
                GiftStore.create(giftId, message ? message : Tr('n.txt'), self.profile.id, (err: string) => {
                    new FeedbackPanel(self.scene, err, undefined, false).show();
                }, () => {
                    new FeedbackPanel(self.scene, Tr('gft.snt'), undefined, true).show();
                });
            });
            gp.openAnimated();
        });
    }

    private createGiftGemsButton(): PlayerActionButton {
        const self = this;

        // КНОПКА "ПОДАРИТЬ ИЗУМРУДЫ"
        return new PlayerActionButton(self.scene, 0, 0, Tr('gift.gems'), undefined, Keys.UI_PROFILE_GIFT_GEMS, 110, () => {
            PlayerStore.getManual('buyGems').then(text => {
                const giftGemsPanel = new GiftGemsPanel(self.scene, self.canvas!, text, self.profile, self.giftGemsCallback);
                giftGemsPanel.openAnimated();
            });
        });
    }

    private createMultsButton(): PlayerActionButton {
        const self = this;

        return new PlayerActionButton(self.scene, 0, 0, Tr('mults'), Keys.ATLAS_PROFILE, Keys.UI_PROFILE_HELP, 100, () => {
            window.open('/api/mult/player/' + self.profile.id);
        });
    }

    private createBanButton(): PlayerActionButton {
        const self = this;

        if (self.profile.ban) {
            return new PlayerActionButton(self.scene, 0, 0, Tr('unban'), Keys.ATLAS_UI, Keys.UI_PROFILE_BAN, 100, () => {
                const cp = new ConfirmationPanel(self.scene, self.canvas!, () => {
                    if (self.onPlayerBanCallback != null) {
                        self.onPlayerUnbanCallback(self.profile.id);
                    }
                }, Tr('podtverzhdenie'), Tr('unban.question'), Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK);
                cp.openAnimated();
            });
        } else {
            return new PlayerActionButton(self.scene, 0, 0, Tr('zabanit.igroka'), Keys.ATLAS_UI, Keys.UI_PROFILE_BAN, 100, () => {
                new ProfileBanPanel(self.scene, self.canvas!, (timeInSeconds: number) => {
                    new BanReasonPanel(self.scene, self.canvas!, (banReason: BanReason) => {
                        if (self.onPlayerBanCallback != null) {
                            self.onPlayerBanCallback(timeInSeconds, banReason, self.profile.id);
                        }
                    }).openAnimated();
                }).open();
            });
        }
    }

    private createEnterAsPlayerButton(): PlayerActionButton {
        const self = this;

        return new PlayerActionButton(self.scene, 0, 0, Tr('log.in.as.a.player'), Keys.ATLAS_UI, Keys.UI_PROFILE_EXIT,100,() => {
            PlayerStore.techEnter(self.profile.id).then(() => {
                window.location.reload();
            });
        });
    }

    private createHistoryButton(): PlayerActionButton {
        const self = this;

        return new PlayerActionButton(self.scene, 0, 0, Tr('history'), Keys.ATLAS_PROFILE, Keys.UI_PROFILE_SOCIAL,100,() => {
            self.historyCallback();
        });
    }

    private createPaymentsButton(): PlayerActionButton {
        const self = this;

        return new PlayerActionButton(self.scene, 0, 0, Tr('payments'), Keys.ATLAS_PROFILE, Keys.UI_PAYMENT_CHANGE,100,() => {
            self.paymentsCallback();
        });
    }

    private createUpgradeToModerButton(finishCallback: CallableFunction): PlayerActionButton | undefined {
        const self = this;

        if (self.profile.accessLevel === AccessLevel.PLAYER) {
            return new PlayerActionButton(self.scene, 0, 0, Tr('moderator.upgrade'), undefined, Keys.CL_UP, 100, () => {
                ModerStore.toModer(self.profile.id).then(() => {
                    new FeedbackPanel(self.scene, Tr('moderator.upgrade.success'), undefined, true).show();
                    self.profile.accessLevel = AccessLevel.MODERATOR;
                    finishCallback();
                });
            });
        } else if (self.profile.accessLevel === AccessLevel.MODERATOR) {
            return new PlayerActionButton(self.scene, 0, 0, Tr('moderator.downgrade'), undefined, Keys.CL_DOWN, 100, () => {
                ModerStore.fromModer(self.profile.id).then(() => {
                    new FeedbackPanel(self.scene, Tr('moderator.downgrade.success'), undefined, true).show();
                    self.profile.accessLevel = AccessLevel.PLAYER;
                    finishCallback();
                });
            });
        }
    }

    private createClanActionButton(ca: ClanControlAction, finishCallback: CallableFunction): PlayerActionButton {
        const self = this;

        return new PlayerActionButton(self.scene, 0, 0, ClanUtils.getActionName(ca), undefined, ClanUtils.getProfileActionImg(ca),100,() => {
            ClanStore.participantAction(self.profile.id, ca).then((ci: ClanmanInfo) => {
                new FeedbackPanel(self.scene, ClanUtils.getActionFeedback(ca), undefined, true).show();
                self.profile.clanControlActions = ci.clanControlActions;
                finishCallback();
            });
        });
    }

    private createPlayerActionButton(a: PlayerAction, finishCallback: CallableFunction): PlayerActionButton {
        const self = this;

        return new PlayerActionButton(self.scene, 0, 0, ProfileUtils.getActionName(a), Keys.ATLAS_PROFILE, Keys.UI_PROFILE_BLOCK, 110, () => {
            const cp = new ConfirmationPanel(self.scene, self.canvas!, () => {
                PlayerStore.playerAction(self.profile.id, a).then(() => {
                    new FeedbackPanel(self.scene!, ProfileUtils.getActionFeed(a), undefined, true).show();
                    if (a === PlayerAction.BLOCK) {
                        self.profile.playerActions = self.profile.playerActions.filter(act => act !== a);
                        self.profile.playerActions.push(PlayerAction.UNBLOCK);
                        finishCallback();
                    } else if (a === PlayerAction.UNBLOCK) {
                        self.profile.playerActions = self.profile.playerActions.filter(act => act !== a);
                        self.profile.playerActions.push(PlayerAction.BLOCK);
                        finishCallback();
                    }
                });
            }, ProfileUtils.getActionName(a), ProfileUtils.getActionText(a), Keys.UI_GOLDEN_CHECK, Tr('da'), Tr('net'), Keys.ATLAS_PROFILE);
            cp.openAnimated();
        });
    }

    private invokeSocialButtonCallback(src: UserSource) {
        switch (src) {
            case UserSource.vk:
                return window.open('https://vk.com/public212337955', '_blank');
            case UserSource.ok:
                return window.open('https://ok.ru/group/63068632907959', '_blank');
        }
    }


    private closeProfilePanel(): void {
        if (this.onCloseCallback) {
            this.onCloseCallback();
        }
    }

    private static getLevelInfo(accessLevel: AccessLevel): string {
        switch (accessLevel) {
            case AccessLevel.MODERATOR:
                return Tr('moder');
            case AccessLevel.ADMIN:
                return Tr('admin');
            case AccessLevel.GOD:
                return Tr('god');
        }
        return Tr('good.fellow');
    }
}
